import '../scss/styles.scss';

/* PDF-links openen in een nieuw venster */
document.querySelectorAll('a').forEach((linkElem: Element) => {
	if (linkElem.hasAttribute('href') && linkElem.getAttribute('href')?.endsWith('.pdf')) {
		linkElem.setAttribute('target', '_blank');
	}
});

/* E-mailadressen tegen spam: de delen staan los in de HTML en worden hier
   samengevoegd tot een mailto-link. */
setTimeout(function () {
	const mailElement = document.querySelectorAll('[data-madr1]:not(.madr-done)');

	mailElement.forEach((mail: Element) => {
		const maddr = mail.getAttribute('data-madr1') + '@' + mail.getAttribute('data-madr2') + '.' + mail.getAttribute('data-madr3');
		const linktext = mail.getAttribute('data-linktext') ? mail.getAttribute('data-linktext') : maddr;

		const a = document.createElement('a');
		a.setAttribute('href', `mailto:${maddr}`);
		a.innerHTML = linktext || '';

		if (mail.parentElement) mail.parentElement.appendChild(a);
		mail.classList.add('madr-done');
		(mail as HTMLElement).style.display = 'none';
	});
}, 500);

/* Knop terug naar boven */
const themeTop = document.querySelector('#theme-to-top');
if (themeTop) {
	themeTop.addEventListener('click', (e) => {
		e.preventDefault();

		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth',
		});
	});
}

/* Scrollgedrag: schaduw onder de navigatie en de knop terug naar boven.

   De handler is passief en rekent hooguit een keer per beeldframe, zodat
   scrollen niet gaat haperen op lange pagina's. De hoogte van de balk
   verandert niet tijdens het scrollen en wordt daarom alleen bij resize
   opnieuw gemeten. */
const navheader = document.querySelector('#theme-page-navigation') as HTMLElement | null;
const bc = document.querySelector('.theme-page-breadcrumb') as HTMLElement | null;
const toTop = document.querySelector('#theme-to-top') as HTMLElement | null;

if (navheader || bc || toTop) {
	let navHeight = 0;
	let ticking = false;

	const measure = () => {
		navHeight = navheader ? navheader.offsetHeight : 0;
	};

	const update = () => {
		ticking = false;

		if (navheader) {
			navheader.classList.toggle('theme-nav-scrolled', window.scrollY > 8);
		}

		if (toTop) {
			toTop.classList.toggle('theme-top-visible', window.scrollY > 200);
		}
	};

	measure();
	update();

	window.addEventListener('scroll', () => {
		if (ticking) return;
		ticking = true;
		requestAnimationFrame(update);
	}, { passive: true });

	window.addEventListener('resize', measure);
}

/* Citatenslider ("Wat opdrachtgevers zeggen").

   De citaten staan in de HTML allemaal onder elkaar; zonder script blijft dat
   zo en zijn de knoppen verborgen. Dit script zet .is-ready op het blok,
   waarna de CSS er een slider van maakt: een citaat tegelijk, met vorige,
   volgende en een teller. Geen automatisch wisselen -- een citaat moet je
   kunnen uitlezen.

   Markup komt uit /Portals/0/2sxc/Content/bs5/Person/Citaten.cshtml. */
document.querySelectorAll('[data-bond-quotes]').forEach((slider: Element) => {
	const slides = Array.from(slider.querySelectorAll('.bond-quote')) as HTMLElement[];
	const status = slider.querySelector('[data-bond-quotes-status]');
	const prev = slider.querySelector('[data-bond-quotes-prev]');
	const next = slider.querySelector('[data-bond-quotes-next]');
	if (slides.length < 2 || !prev || !next) return;

	let current = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));

	const show = (index: number) => {
		current = (index + slides.length) % slides.length;
		slides.forEach((slide, i) => {
			const active = i === current;
			slide.classList.toggle('is-active', active);
			slide.setAttribute('aria-hidden', active ? 'false' : 'true');
		});
		if (status) status.textContent = `${current + 1} / ${slides.length}`;
	};

	prev.addEventListener('click', () => show(current - 1));
	next.addEventListener('click', () => show(current + 1));

	// Pijltjestoetsen werken zodra de focus in het blok staat.
	slider.addEventListener('keydown', (e: Event) => {
		const key = (e as KeyboardEvent).key;
		if (key === 'ArrowLeft') show(current - 1);
		if (key === 'ArrowRight') show(current + 1);
	});

	slider.classList.add('is-ready');
	show(current);
});

/* Uitklapblokken: een link naar een anker binnen een dichtgeklapt blok
   (bijvoorbeeld /#faq) opent dat blok, zodat je niet op een lege plek landt. */
const openFromHash = () => {
	if (!window.location.hash) return;
	const target = document.getElementById(window.location.hash.slice(1));
	const details = target?.closest('details');
	if (details) details.open = true;
};
openFromHash();
window.addEventListener('hashchange', openFromHash);

/* Het uitschuifmenu sluiten als je op een ankerlink klikt (/#aanbod). De
   pagina scrollt dan naar de sectie, maar het paneel zou er anders overheen
   blijven liggen. */
document.querySelectorAll('#offcanvasNavbar a[href*="#"]').forEach((link: Element) => {
	link.addEventListener('click', () => {
		const close = document.querySelector('#offcanvasNavbar .btn-close') as HTMLElement | null;
		if (close) close.click();
	});
});

/* Het menu volgt het scrollen op de homepage.

   Aanbod, Over, Resultaten en Contact zijn ankerlinks (/Home#over). DNN ziet
   die niet als de huidige pagina en maakt ze dus nooit actief. Hier krijgt het
   item van de sectie die in beeld is dezelfde klassen als een actieve pagina
   (vet, streepje in de primaire kleur), in het gewone en het mobiele menu.

   Alleen links naar deze pagina tellen mee: een #contact op de pagina
   Trainingen hoort niet bij het menu-item Contact van de homepage. De
   homepage is bereikbaar als / en als /Home. */
const norm = (path: string) => path.toLowerCase().replace(/\/+$/, '');
const onHomeLayout = document.body.classList.contains('theme-variation-home');
const pointsHere = (a: HTMLAnchorElement) => {
	if (a.host !== window.location.host) return false;
	const here = norm(window.location.pathname);
	const there = norm(a.pathname);
	return there === here || (onHomeLayout && (there === '' || there === '/home') && (here === '' || here === '/home'));
};
const hashId = (a: HTMLAnchorElement) => decodeURIComponent(a.hash.slice(1));

const spyLinks = (Array.from(document.querySelectorAll('.nav-anchor > .nav-link')) as HTMLAnchorElement[])
	.filter((a) => a.hash.length > 1 && pointsHere(a) && document.getElementById(hashId(a)));

if (spyLinks.length) {
	const ids = Array.from(new Set(spyLinks.map(hashId)));
	const sections = ids.map((id) => document.getElementById(id) as HTMLElement);
	let current: string | null = null;
	let spyTicking = false;

	const setActive = (id: string) => {
		if (id === current) return;
		current = id;
		spyLinks.forEach((a) => {
			const on = hashId(a) === id;
			a.classList.toggle('active', on);
			a.parentElement?.classList.toggle('active', on);
			if (on) a.setAttribute('aria-current', 'location');
			else a.removeAttribute('aria-current');
		});
	};

	// Actief = de sectie waar een lijn op een kwart onder de menubalk doorheen
	// loopt. Onderaan de pagina (waar de laatste sectie die lijn misschien nooit
	// haalt) wint de laagste sectie die in beeld is. Tussen twee menusecties,
	// bijvoorbeeld bij de cijferbalk, is niets actief.
	const spy = () => {
		spyTicking = false;
		const line = (navheader ? navheader.offsetHeight : 0) + window.innerHeight * 0.25;
		const atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
		let best = '';
		let bestTop = -Infinity;
		sections.forEach((section, i) => {
			const r = section.getBoundingClientRect();
			const inView = atBottom ? r.top < window.innerHeight && r.bottom > 0 : r.top <= line && r.bottom > line;
			if (inView && r.top > bestTop) {
				bestTop = r.top;
				best = ids[i];
			}
		});
		setActive(best);
	};

	spy();
	window.addEventListener('scroll', () => {
		if (spyTicking) return;
		spyTicking = true;
		requestAnimationFrame(spy);
	}, { passive: true });
	window.addEventListener('resize', spy);
}

/* Ankerlinks naar deze pagina niet herladen.

   Het menu linkt naar /Home#over, ook als je op / staat. De browser ziet dat
   als een andere URL en laadt de pagina opnieuw. Hier blijft het bij scrollen:
   de hash gaat via pushState in de adresbalk (terug-knop werkt), en de CSS
   zorgt voor smooth scroll en ruimte onder de vaste menubalk. In het
   uitschuifmenu wachten we tot het paneel dicht is, want zolang het open is
   staat scrollen op de pagina uit. */
const scrollToHash = (id: string) => {
	const target = document.getElementById(id);
	if (!target) return;
	history.pushState(null, '', `#${encodeURIComponent(id)}`);
	openFromHash();
	target.scrollIntoView();
};

document.querySelectorAll('a[href*="#"]').forEach((el: Element) => {
	const a = el as HTMLAnchorElement;
	if (a.hash.length < 2 || !pointsHere(a)) return;

	a.addEventListener('click', (e: MouseEvent) => {
		if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
		const id = hashId(a);
		if (!document.getElementById(id)) return;
		e.preventDefault();

		const offcanvas = a.closest('#offcanvasNavbar');
		if (offcanvas && offcanvas.classList.contains('show')) {
			offcanvas.addEventListener('hidden.bs.offcanvas', () => scrollToHash(id), { once: true });
		} else {
			scrollToHash(id);
		}
	});
});

/* Kruimelpad: op een smal scherm wordt het pad ingekort tot "..." plus de
   huidige pagina. De trigger klapt de rest weer uit. */
if (bc) {
	const bcTrigger = bc.querySelector('.breadcrumb-item-trigger') as HTMLElement | null;
	const bcHome = bc.querySelector('.breadcrumb-item-home') as HTMLElement | null;

	if (bcTrigger && bcHome) {
		bcTrigger.addEventListener('click', () => {
			bcHome.style.display = bcHome.style.display === 'none' ? 'inline-block' : 'none';
		});

		const many = bc.querySelectorAll('.breadcrumb-item').length > 2;
		bcTrigger.style.display = many ? 'inline-block' : 'none';
		bcHome.style.display = many ? 'none' : 'inline-block';
	}
}
